export default "__VITE_ASSET__7e4581fa__"